import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Input, Button, Upload, Typography, Spin } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const { Title } = Typography;
const { Dragger } = Upload;

const AddServices = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const user = JSON.parse(localStorage.getItem("admin"));

  const handleImageChange = (info) => {
    const file = info.fileList[0]?.originFileObj;
    if (file) setImageFile(file);
  };

  const onFinish = async (values) => {
    if (!imageFile) {
      toast.error(t("add_new_product_T_img_info"));
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("image", imageFile);
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("url", values.url || "");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIURL}/admin/createservice`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          body: formData,
        }
      );
      const result = await response.json();
      if (result.status_code === 200) {
        toast.success(t("Add_Service_success"));
        navigate(-1);
      } else {
        toast.error(result.message || result.err || "Failed");
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Helmet>
        <title>{`${t("Admin")} - ${t("Add_Service")}`}</title>
      </Helmet>

      <div className="flex justify-between items-center mb-4">
        <Title level={4}>{t("Add_Service")}</Title>
        <Link to="/admin/settings/general_services">
          <button className="btn btn-primary btn-sm text-white">{t("Back_Service")}</button>
        </Link>
      </div>

      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="bg-white p-6 rounded shadow-sm"
        >
          <Form.Item
            name="title"
            label={
              <>
                {t("Service_Title")} <span className="text-red-600">*</span>
              </>
            }
            rules={[{ required: true, message: t("Service_Title_req") }]}
          >
            <Input placeholder={t("Service_Title")} />
          </Form.Item>

          <Form.Item
            label={
              <>
                {t("Service_Image")} <span className="text-red-600">*</span>
              </>
            }
          >
            <Dragger
              multiple={false}
              accept="image/*"
              beforeUpload={() => false}
              showUploadList={{ showRemoveIcon: true }}
              onChange={handleImageChange}
              maxCount={1}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">{t("Click or drag image")}</p>
            </Dragger>
          </Form.Item>

          <Form.Item
            name="description"
            label={
              <>
                {t("Services_Description")}{" "}
                <span className="text-red-600">*</span>
              </>
            }
            rules={[{ required: true, message: t("Services_Description_req") }]}
          >
            <Input placeholder={t("Services_Description")} />
          </Form.Item>

          <Form.Item name="url" label={t("Url")}>
            <Input placeholder={t("Url")} />
          </Form.Item>

          <Form.Item>
            <button type="submit" className="btn btn-primary btn-sm text-white">
              {t("Add_Service")}
            </button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};

export default AddServices;
